import React from 'react';
import { Mail, Linkedin } from 'lucide-react';

/** LayoutFooter – Copy from JSON (footer.tagline, footer.contactEmail, footer.linkedinUrl). Link labels stay in code. */
export default function LayoutFooter({ onNavigate, content }) {
  const footer = content || {};
  const title = footer.title ?? '';
  const tagline = footer.tagline ?? '';
  const contactEmail = footer.contactEmail ?? '';
  const linkedinUrl = footer.linkedinUrl ?? 'https://www.linkedin.com';

  const handleFooterNav = (e, sectionId) => {
    e.preventDefault();
    if (sectionId === 'about' || sectionId === 'work' || sectionId === 'casestudies') {
      window.location.hash = `#${sectionId}`;
      return;
    }
    if (sectionId === 'products') {
      window.location.hash = '#';
      setTimeout(() => {
        const el = document.getElementById('products');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 120);
      return;
    }
    if (sectionId === 'services') {
      window.location.hash = '#';
      setTimeout(() => {
        const el = document.getElementById('services');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 120);
      return;
    }
    if (sectionId) {
      window.location.hash = '#';
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (onNavigate) onNavigate(sectionId);
      }, 120);
    }
  };

  const servicesLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Products', href: '#products' },
    { label: 'Case studies', href: '#casestudies' },
  ];
  const companyLinks = [
    { label: 'Who We Are', href: '#about' },
    { label: 'Work', href: '#work' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <footer className="py-9 md:py-10 border-t" style={{ background: 'var(--jb-forest-bg)', borderColor: 'var(--jb-border)' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
          <div className="sm:col-span-2 md:col-span-1">
            <div className="font-display font-extrabold text-lg text-text-hero">
              {title?.replace(/\s*Brick\s*/i, '') || 'Jungle'}<span className="text-cyan">.</span>Brick
            </div>
            {tagline && <p className="font-body text-text-sub text-sm mt-1">{tagline}</p>}
          </div>
          <div>
            <h4 className="font-mono text-text-muted text-xs uppercase tracking-widest mb-3">Services</h4>
            <ul className="space-y-2 text-sm">
              {servicesLinks.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleFooterNav(e, link.href.replace('#', '')); }}
                    className="font-body text-text-sub hover:text-cyan transition"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-text-muted text-xs uppercase tracking-widest mb-3">Company</h4>
            <ul className="space-y-2 text-sm">
              {companyLinks.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleFooterNav(e, link.href.replace('#', '')); }}
                    className="font-body text-text-sub hover:text-cyan transition"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-8 border-t flex flex-col sm:flex-row items-center justify-between gap-4" style={{ borderColor: 'var(--jb-border)' }}>
          <div className="flex items-center gap-4">
            {contactEmail && (
              <a
                href={`mailto:${contactEmail}`}
                className="flex items-center gap-2 font-body text-sm text-text-sub hover:text-cyan transition"
              >
                <Mail className="w-4 h-4" />
                <span className="break-all">{contactEmail}</span>
              </a>
            )}
            <a
              href={linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-muted hover:text-cyan transition p-1"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-5 h-5" />
            </a>
          </div>
          <p className="font-body text-sm text-text-muted">
            © {new Date().getFullYear()} {title || 'Jungle Brick'}. All rights reserved.
          </p>
          <span className="font-mono text-xs text-cyan tracking-widest">CLOUD · SECURE · SCALABLE</span>
        </div>
      </div>
    </footer>
  );
}
